import contactOwnerFormActions from '../actions/contactOwnerFormActions';
import {hasTooManyAdults, getMaxAdultsFromHouseRules} from '../utils/guests';
import {isFuture, isDateString} from '../utils/dateHelper';

const {contactOwnerFormChanged, contactOwnerFormFieldValid} = contactOwnerFormActions;

const FIRSTNAME_FIELD = 'firstName';
const LASTNAME_FIELD = 'lastName';
const EMAIL_FIELD = 'emailAddress';
const TERMS_AND_CONDITIONS_AGREED = 'termsAndConditionsAgreed';

const VALID_EMAIL_REGEX = /^([a-zA-Z0-9_\-\.+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,64}|[0-9]{1,3})(\]?)$/;

const notBlank = (str) => !!(str && str.trim() !== '');

const validEmailAddress = (email) =>
    !!(email && email.match(VALID_EMAIL_REGEX) && !email.endsWith('@homeaway.com'));

// takes in field name and value
// returns true or false based on the
// validation criteria for that field
function isFieldValid(field, value) {
    switch (field) {
        case FIRSTNAME_FIELD:
        case LASTNAME_FIELD:
            return notBlank(value);
        case TERMS_AND_CONDITIONS_AGREED:
            return !!value;

        case EMAIL_FIELD:
            return validEmailAddress(value);

        default:
            return true;
    }
}

function validateField(store, action = {payload: {}}) {
    const {
        payload: {field, value}
    } = action;

    store.dispatch(contactOwnerFormFieldValid(field, isFieldValid(field, value)));
}

function contactOwnerFormFieldEdited(store, action = {payload: {}}) {
    const {
        payload: {field, value}
    } = action;

    store.dispatch(
        contactOwnerFormChanged({
            [field]: value
        })
    );

    validateField(store, action);
}

function contactOwnerFormFieldTouched(store, action = {payload: {}}) {
    validateField(store, action);
}

function clientSideValidate(store) {
    const state = store.getState();
    const {adults, children, arriveDateText} = state.tripDetailsReducer;
    const {houseRules, sleeps} = state.listingReducer;
    const maxAdults = getMaxAdultsFromHouseRules({houseRules, sleeps});
    let noErrors = true;

    if (adults === 0 || adults + children > sleeps || hasTooManyAdults({adults, maxAdults})) {
        store.dispatch(contactOwnerFormActions.contactOwnerFormFieldValid('guests', false));
        noErrors = false;
    }

    if (isDateString(arriveDateText) && !isFuture(arriveDateText)) {
        store.dispatch(contactOwnerFormActions.contactOwnerFormFieldValid('dates', false));
        noErrors = false;
    }

    if (!noErrors) {
        // Reset scrollTop in case it needs to be scrolled again
        store.dispatch(contactOwnerFormActions.scrollTop(false));
        store.dispatch(contactOwnerFormActions.scrollTop(true));
    }

    return noErrors;
}

// Returns true if all the fields are valid
function contactOwnerFormValidateForm(store) {
    const state = store.getState();
    const inquiryFormData = state.contactOwnerFormReducer;
    const fieldNames = [FIRSTNAME_FIELD, LASTNAME_FIELD, EMAIL_FIELD, TERMS_AND_CONDITIONS_AGREED];

    let formIsValid = true;

    formIsValid = clientSideValidate(store);

    for (let fieldName of fieldNames) {
        let fieldValue = inquiryFormData[fieldName];
        let fieldIsValid = isFieldValid(fieldName, fieldValue);

        if (fieldIsValid === false) {
            store.dispatch(
                contactOwnerFormActions.contactOwnerFormFieldTouched(fieldName, fieldValue)
            );
            formIsValid = false;
        }
    }

    return formIsValid;
}

export {contactOwnerFormFieldEdited, contactOwnerFormFieldTouched, contactOwnerFormValidateForm};
